  /* ---------- hero: what is on now ---------- */

  function heroShows(w) {
    return w.side === 'selective' && w.image;
  }

  function heroSlides() {
    /* the designers' shelf alone; no exhibitions in the rotation */
    return S.works.filter(heroShows).map(function (w) {
      const m = makerById[w.maker_id];
      return {
        img: w.image,
        side: w.side,
        title: m.name,
        /* a material phrase holds together and a wrapped line leads with its
           dot: the only break point is the space before each separator */
        desc: w.material.split(/,\s*/).map(function (line) {
          return line.split(' · ').map(function (phrase) {
            return phrase.replace(/ /g, '\u00a0');
          }).join(' ·\u00a0');
        }).join('\n'),
        meta: w.title + '\n' + (w.status === 'sold' ? said('status', w.status) : fmtKRW(w.price)),
        href: itemHref(w)
      };
    });
  }

  /* stillness before the hero advances, counted afresh after a step by hand */
  const HERO_STILL_MS = 7000;
  /* a step shows its photograph decoded, or after this long undecoded */
  const HERO_DECODE_MS = 4000;

  function renderHero() {
    const slides = heroSlides();
    if (!slides.length) return;
    const stage = document.getElementById('hero-stage');
    const hero = document.getElementById('hero');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let idx = 0, timer = null;
    const q = parseInt(param('slide'), 10);
    if (!isNaN(q) && q >= 1 && q <= slides.length) idx = q - 1;

    /* only the photograph on show and its two neighbours stand in the stage */
    const imgs = {};
    /* the section renders the first photograph itself (sections/landing.liquid)
       so it does not wait for the scripts; kept where its address agrees */
    const standing = stage.querySelector('.hero-img');
    if (standing) {
      if (standing.src !== new URL(slides[0].img, location.href).href) standing.src = slides[0].img;
      imgs[0] = standing;
    }
    function mount(n) {
      if (imgs[n]) return imgs[n];
      const im = document.createElement('img');
      im.className = 'hero-img';
      im.alt = '';
      im.loading = 'eager';
      /* anonymous, or a canvas drawn from the CDN image taints and every
         label falls back to paper */
      im.crossOrigin = 'anonymous';
      im.src = slides[n].img;
      stage.appendChild(im);
      imgs[n] = im;
      return im;
    }
    function decoded(im) {
      if (!im.decode) return Promise.resolve();
      return Promise.race([
        im.decode().catch(function () {}),
        new Promise(function (r) { setTimeout(r, HERO_DECODE_MS); })
      ]);
    }
    function paint(n, d) {
      const prev = (n - 1 + slides.length) % slides.length, next = (n + 1) % slides.length;
      const im = mount(n);
      mount(prev); mount(next);
      decoded(im).then(function () {
        /* a step overtaken while it decoded leaves the paint to the newer one */
        if (n !== idx) return;
        Object.keys(imgs).forEach(function (k) {
          const i = Number(k);
          imgs[k].classList.toggle('on', i === n);
          if (i !== n && i !== prev && i !== next) { imgs[k].remove(); delete imgs[k]; }
        });
        hero.dispatchEvent(new CustomEvent('hero:change', {
          bubbles: true,
          detail: { index: n, direction: d, slide: slides[n], img: im, count: slides.length }
        }));
      });
    }
    function step(d) {
      idx = (idx + d + slides.length) % slides.length;
      paint(idx, d);
    }
    function schedule(ms) {
      if (reduce) return;
      clearTimeout(timer);
      timer = setTimeout(function () { step(1); schedule(HERO_STILL_MS); }, ms);
    }
    function go(d) { step(d); schedule(HERO_STILL_MS); }

    hero.addEventListener('hero:change', turnLabels);
    hero.addEventListener('hero:change', function (e) { toneImg = e.detail.img; electTones(); electAgain(); });
    window.addEventListener('resize', electAgain);
    /* the same gesture as the other carousels (pages.js swipeStepper), by hand too */
    swipeStepper(go)(hero, true);
    document.getElementById('hero-prev').addEventListener('click', function () { go(-1); });
    document.getElementById('hero-next').addEventListener('click', function () { go(1); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    /* the phone alone, whose hero fills the screen and has nowhere else to go */
    hero.addEventListener('click', function (e) {
      if (!isPhone() || e.target.closest('a, button')) return;
      const door = document.querySelector('.mt-center[href]');
      if (door) location.href = door.getAttribute('href');
    });
    paint(idx, 0);
    schedule(HERO_STILL_MS);
  }

  /* the labels turn to the photograph that has just arrived (hero:change) */
  function turnLabels(e) {
    const s = e.detail.slide, n = e.detail.index;
    const elSide = document.getElementById('hero-side');
    const elTitle = document.getElementById('hero-title');
    const elMeta = document.getElementById('hero-meta');
    const elCount = document.getElementById('hero-count');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const lines = [
      [elSide, s.title, s.href],
      [elTitle, s.desc, s.href],
      [elMeta, s.meta, null],
      [elCount, String(n + 1).padStart(2, '0') + ' / ' +
        String(e.detail.count).padStart(2, '0'), null]
    ];
    if (reduce || !elSide.animate) {
      lines.forEach(function (l) {
        setMicro(l[0], l[1]);
        if (l[2]) l[0].href = l[2];
        l[0].classList.remove('out');
      });
      return;
    }
    /* the same turn as the post band's caption (pages.js turnLine). The shift
       rides translate and starts from whatever the stylesheet already put
       there: two lines are dropped 96px on some readings, and an animation
       from zero would collapse that for the length of the turn. */
    const OUT_MS = 200, IN_MS = 300, WAVE_SPAN = 160;
    const EASE_OUT = 'cubic-bezier(0, 0, 0.58, 1)';
    const wave = WAVE_SPAN / (lines.length - 1);
    lines.forEach(function (l, i) {
      const el = l[0], text = l[1], href = l[2];
      const base = getComputedStyle(el).translate;
      const y = base && base !== 'none' ? parseFloat(base.split(' ')[1] || '0') || 0 : 0;
      el.getAnimations().forEach(function (a) { a.cancel(); });
      setTimeout(function () {
        el.animate([{ opacity: 1, translate: '0 ' + y + 'px' },
                    { opacity: 0, translate: '0 ' + (y - 20) + 'px' }],
                   { duration: OUT_MS, easing: EASE_OUT, fill: 'forwards' })
          .finished.then(function () {
            /* the fill is dropped the moment the new line is drawn */
            el.getAnimations().forEach(function (a) { a.cancel(); });
            setMicro(el, text);
            if (href) el.href = href;
            /* toned before it rises, or the fresh text fades in untoned until the rerun */
            electTones();
            el.classList.remove('out');
            el.animate([{ opacity: 0, translate: '0 ' + (y + 20) + 'px' },
                        { opacity: 1, translate: '0 ' + y + 'px' }],
                       { duration: IN_MS, easing: EASE_OUT, fill: 'backwards' });
          }, function () { setMicro(el, text); if (href) el.href = href; });
      }, i * wave);
    });
  }

  /* ---------- the labels take their tone from the photograph ----------
     inside the hero every glyph answers its own pixels, since one line can
     cross three grounds no single tone suits; the corners stand outside the
     hero, blend with nothing, and are elected whole. Both read one canvas,
     drawn once per photograph. */
  const GLYPH_LABELS = ['.mt-a', '#hero-side', '#hero-title', '#hero-meta', '#hero-count', '#hero-prev', '#hero-next'];
  const TONE_W = 640;
  let toneImg = null, toneCv = null, toneCtx = null, tonePx = null, toneDrawn = '';

  /* every character its own box, whitespace left so the lines still break */
  function splitGlyphs(el) {
    const text = el.textContent;
    /* the text alone is not proof the split stands: setMicro rewrites the
       contents on every advance, and the same maker arriving twice made a
       text-only guard skip the re-split */
    if (el.__glText === text && el.querySelector('.gl')) return;
    el.__glText = text;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 1) {
          if (!n.classList.contains('gl')) walk(n);
          return;
        }
        if (n.nodeType !== 3 || !n.nodeValue.trim()) return;
        const frag = document.createDocumentFragment();
        n.nodeValue.split('').forEach(function (ch) {
          if (!ch.trim()) { frag.appendChild(document.createTextNode(ch)); return; }
          const sp = document.createElement('span');
          sp.className = 'gl';
          sp.textContent = ch;
          frag.appendChild(sp);
        });
        n.parentNode.replaceChild(frag, n);
      });
    })(el);
  }

  /* the photograph's pixels, read once per photograph rather than per label */
  function ground(img) {
    const key = img.currentSrc || img.src;
    if (toneDrawn === key && tonePx) return true;
    const iw = img.naturalWidth, ih = img.naturalHeight;
    if (!iw || !ih) return false;
    if (!toneCv) { toneCv = document.createElement('canvas'); toneCtx = toneCv.getContext('2d', { willReadFrequently: true }); }
    toneCv.width = TONE_W; toneCv.height = Math.max(1, Math.round(TONE_W * ih / iw));
    try {
      toneCtx.drawImage(img, 0, 0, toneCv.width, toneCv.height);
      tonePx = toneCtx.getImageData(0, 0, toneCv.width, toneCv.height);
    } catch (e) { tonePx = null; return false; }
    toneDrawn = key;
    return true;
  }

  /* Nothing is sampled before the photograph has decoded: an undecoded draw reads
     back black and every label elects the paper voice on cold loads only. A
     photograph that cannot decode is asked once and marked: decode() settles
     either way, and retrying from that settlement is a microtask loop that
     live-locks the page. */
  function toneReady(img, again) {
    if (img.complete && img.naturalWidth) return true;
    if (img.__toneFailed) return false;
    if (!img.__toneWaiting) {
      img.__toneWaiting = true;
      const fire = function () {
        img.__toneWaiting = false;
        if (!(img.complete && img.naturalWidth)) img.__toneFailed = true;
        again();
      };
      if (img.decode) img.decode().then(fire, fire);
      else img.addEventListener('load', fire, { once: true });
    }
    return false;
  }

  function electTones() {
    const img = toneImg, hero = document.getElementById('hero');
    if (!img || !hero) return;
    if (!toneReady(img, electTones) && !img.__toneFailed) return;
    /* a photograph that cannot be read shows the hero's own ink, so nothing is
       measured and every label wears paper */
    const read = ground(img);
    const g = hero.getBoundingClientRect();
    const iw = img.naturalWidth, ih = img.naturalHeight;
    const scale = read ? Math.max(g.width / iw, g.height / ih) : 1;
    const op = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
    const ox = read ? (g.width - iw * scale) * (parseFloat(op[0]) / 100) : 0;
    const oy = read ? (g.height - ih * scale) * (parseFloat(op[1] || '50%') / 100) : 0;
    const kx = read ? toneCv.width / iw : 1, ky = read ? toneCv.height / ih : 1;
    /* the average under a rect and the share of its pixels that are light: a
       straddling corner's average lies, and the share says which side to take */
    function tone(r) {
      if (!read) return null;
      const d = tonePx.data;
      const x0 = Math.max(0, Math.floor(((r.left - g.left - ox) / scale) * kx));
      const y0 = Math.max(0, Math.floor(((r.top - g.top - oy) / scale) * ky));
      const x1 = Math.min(toneCv.width - 1, Math.ceil(((r.right - g.left - ox) / scale) * kx));
      const y1 = Math.min(toneCv.height - 1, Math.ceil(((r.bottom - g.top - oy) / scale) * ky));
      let sum = 0, light = 0, n = 0;
      for (let y = y0; y <= y1; y++) {
        for (let x = x0; x <= x1; x++) {
          const i = (y * toneCv.width + x) * 4;
          const l = (d[i] * 299 + d[i + 1] * 587 + d[i + 2] * 114) / 1000;
          sum += l;
          if (l > 150) light++;
          n++;
        }
      }
      return n ? { avg: sum / n, mix: light / n } : null;
    }
    /* every match, not the first: two labels can share a corner (the cart beside
       the menu door), each still sampling its own rect */
    Array.prototype.forEach.call(document.querySelectorAll('.corner'), function (el) {
      const s = tone(el.getBoundingClientRect());
      const onLight = !!s && s.mix >= 0.5;
      el.classList.toggle('on-light', onLight);
      el.classList.toggle('on-dark', !onLight);
      /* the band is wide (0.15) because a corner's rect is coarse */
      el.classList.toggle('on-mixed', !!s && s.mix > 0.15 && s.mix < 0.85);
    });
    GLYPH_LABELS.forEach(function (sel) {
      const el = hero.querySelector(sel);
      if (!el) return;
      splitGlyphs(el);
      Array.prototype.forEach.call(el.querySelectorAll('.gl'), function (sp) {
        const r = sp.getBoundingClientRect();
        if (!r.width || !r.height) return;
        const s = tone(r);
        sp.dataset.mglyph = s && s.avg > 128 ? 'ink' : 'paper';
      });
    });
  }

  /* taken on settle, not per frame: once the turned lines have landed (the
     last setMicro of the wave) and once more after their rise has ended */
  let toneRuns = [];
  function electAgain() {
    toneRuns.forEach(clearTimeout);
    toneRuns = [setTimeout(electTones, 460), setTimeout(electTones, 1040)];
  }

/* wiring: ports as-is */

  /* ---------- how the hero gives up its place ----------
     hold: drawn back a fifth of its own height over the leave, so it climbs at
     four fifths of the page's speed */
  function wireHero(mode) {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const corners = Array.prototype.slice.call(document.querySelectorAll('.corner'));
    let overPaper = false, overPhoto = false;
    /* looked up lazily: the plate builds itself after the hero, the register's
       stage later still */
    let plateBox, sheetBox, footerBox;

    /* promoted by the one mode that moves it, so no stylesheet gate has to
       mirror the choice; a tablet's hero once sat on a layer that stopped
       repainting under a hint nothing moved */
    if (mode === 'hold') hero.style.willChange = 'transform';

    function frame() {
      /* the next frame is claimed before any work: a throw would otherwise take
         the loop with it */
      requestAnimationFrame(frame);
      const box = hero.getBoundingClientRect();
      if (mode === 'hold') {
        const through = Math.min(1, Math.max(0, -box.top / Math.max(1, box.height)));
        hero.style.transform = 'translate3d(0,' + (through * 20).toFixed(2) + '%,0)';
      }
      /* past the hero's foot the corners stand on the plate's pinned painting,
         where per-image tone means nothing: they are told plainly to go to ink
         and given back what they wore on the way out */
      plateBox = plateBox || document.querySelector('.plate');
      sheetBox = sheetBox || document.querySelector('.dz-stage');
      footerBox = footerBox || document.getElementById('site-footer');
      const onPhoto = box.bottom < 60 && coversLabels(plateBox) &&
        !coversLabels(sheetBox) && !coversLabels(footerBox);
      if (onPhoto !== overPhoto) {
        overPhoto = onPhoto;
        corners.forEach(function (el) {
          if (onPhoto) {
            el.dataset.wasLight = el.classList.contains('on-light') ? '1' : '';
            el.classList.add('on-dark');
            el.classList.remove('on-light');
          } else if (el.dataset.wasLight) {
            el.classList.add('on-light');
            el.classList.remove('on-dark');
            delete el.dataset.wasLight;
          }
        });
      }
      const paper = box.bottom < 60 && !onPhoto;
      if (paper !== overPaper) {
        overPaper = paper;
        corners.forEach(function (el) { el.classList.toggle('on-paper', paper); });
      }
    }
    requestAnimationFrame(frame);
  }

  /* whether a thing is drawn across the labels' own line */
  function coversLabels(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.top < 60 && r.bottom > 0;
  }
